import React from 'react';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  hoverClassName?: string;
  disabledClassName?: string;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  onClick,
  disabled = false,
  disabledClassName = '!opacity-50',
  hoverClassName = 'hover:opacity-90',
  className = '',
  style,
  id,
  ...rest
}) => {
  return (
    <button
      id={id}
      style={style}
      className={`
        linear-background-color-primary
        text-white
        cursor-pointer
        transition-all
        duration-500
        capitalize
        shadow-[0_10px_30px_5px_rgba(42,163,70,0.2)]
        rounded-[100px]
        h-fit
        w-fit
        py-4
        px-10
        border-none
        ${hoverClassName}
        ${disabled && disabledClassName}
        ${className}
      `}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
